<template>
  <w-icon-wrapper
    :height='19.778'
    :width='24'
    icon-name='work-edit-view-icon'
    view-box='0 0 24 19.778'
  >
    <g
      id='_21_Ansicht_bearbeiten_Icon'
      data-name='21 Ansicht bearbeiten_Icon'
      transform='translate(0 -2.267)'
    >
      <path
        id='Pfad_55684'
        d='M12.851,14.99A8.046,8.046,0,0,1,2.735,11.75a7.949,7.949,0,0,1,6.9-3.91,8.067,8.067,0,0,1,6.014,2.66c.443-.71.885-1.43,1.306-2.11A10.627,10.627,0,0,0,9.633,5.5,10.393,10.393,0,0,0,.226,11.27L0,11.75l.226.48A10.393,10.393,0,0,0,9.633,18a10.991,10.991,0,0,0,1.409-.09C11.515,17.15,12.142,16.14,12.851,14.99Z'
        data-name='Pfad 55684'
        fill='currentColor'
      />
      <path
        id='Pfad_55685'
        d='M6.827,11.75A2.812,2.812,0,1,0,9.638,9.016,2.774,2.774,0,0,0,6.827,11.75Zm3.566,0a.755.755,0,1,1-.755-.734A.745.745,0,0,1,10.393,11.75Z'
        data-name='Pfad 55685'
        fill='currentColor'
      />
      <path
        id='Pfad_55686'
        d='M23.739,2.96a10.545,10.545,0,0,0-1.029-.59.831.831,0,0,0-.534-.09.846.846,0,0,0-.483.43c-.113.17-1.923,3.08-4.02,6.45-.442.72-.905,1.47-1.368,2.21-.514.83-1.038,1.66-1.531,2.46-.9,1.43-1.717,2.76-2.355,3.8-.843,1.34-1.377,2.21-1.377,2.21s-.185,2,.1,2.19a.35.35,0,0,0,.206,0,9.608,9.608,0,0,0,1.809-.98s1.594-2.56,3.547-5.71c.011,0,.011-.01.011-.02.771-1.24,1.6-2.57,2.416-3.88C21.518,7.59,23.739,4,23.862,3.78,24.129,3.28,23.965,3.09,23.739,2.96Z'
        data-name='Pfad 55686'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconEditView' };
</script>
